const state = {
  retailSelected: null,
  cellClicked: null,
  gridIsReady: false,
  dateList: [],
  dateRange: {
    dateStart: '',
    dateEnd: ''
  }
}

const getters = {

}

const mutations = {
  commit_priceAudition_cellClicked (state, cellClicked) {
    state.cellClicked = cellClicked
  },
  commit_priceAudition_dateRange (state, dateRange) {
    state.dateRange = dateRange
  },
  commit_priceAudition_dateList (state, dateList) {
    state.dateList = dateList
  },
  commit_priceAudition_retailSelected (state, retailSelected) {
    state.retailSelected = retailSelected
  },
  commit_priceAudition_gridIsReady (state, gridIsReady) {
    state.gridIsReady = gridIsReady
  }
}

export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/priceAudition.js